/* Google V2 — galerie d'arguments (flèches, légende), vidéos paresseuses, lecteur explicatif, carrousel d'avis, FAQ (pastilles), barre collante 7 raisons, Trustpilot. Aucune dépendance. */
(function () {
  var root = document.querySelector('.gv2');
  if (!root) return;

  function addSources(v, list) {
    list.split('|').forEach(function (s) {
      if (!s) return;
      var el = document.createElement('source');
      el.src = s; el.type = /\.webm(\?|$)/.test(s) ? 'video/webm' : 'video/mp4';
      v.appendChild(el);
    });
  }
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* ── Vidéos en boucle : chargées quand elles approchent, jouées quand visibles ── */
  var vids = [].slice.call(root.querySelectorAll('video[data-src][muted]'));
  function loadVid(v) { if (v.dataset.loaded) return; if (v.getAttribute('data-poster')) v.setAttribute('poster', v.getAttribute('data-poster')); addSources(v, v.getAttribute('data-src') || ''); v.dataset.loaded = '1'; v.load(); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { var v = e.target; if (e.isIntersecting) { loadVid(v); playSafe(v); } else if (!v.paused) { v.pause(); } });
    }, { rootMargin: '200px 0px', threshold: 0.05 });
    vids.forEach(function (v) { io.observe(v); });
  } else { vids.forEach(function (v) { loadVid(v); playSafe(v); }); }

  /* ── Galerie hero ── */
  var main = root.querySelector('#gv2-gal-main');
  var thumbs = [].slice.call(root.querySelectorAll('.g-thumb'));
  var mainImg = main && main.querySelector('img.gal-img');
  var mainVid = main && main.querySelector('video.gal-vid');
  var cap = root.querySelector('#gv2-gal-cap');
  var sizesAttr = mainImg ? (mainImg.getAttribute('sizes') || '') : '';
  var warmed = {};
  function warm(t) {
    var img = t.getAttribute('data-img'); if (!img || warmed[img]) return;
    var pre = new Image(); pre.fetchPriority = 'low'; if (t.getAttribute('data-srcset')) { pre.sizes = sizesAttr; pre.srcset = t.getAttribute('data-srcset'); } pre.src = img;
    warmed[img] = pre.decode ? pre.decode().catch(function () {}) : Promise.resolve();
  }
  var layers = main ? [].slice.call(main.querySelectorAll('.g-ov')) : [];
  function setLayer(i) { layers.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-slide') === String(i)); }); }
  var swapToken = 0;
  function showImg(t, img, alt) {
    var token = ++swapToken;
    warm(t);
    // l'échange ne doit jamais attendre : décodage OU 140 ms, le premier des deux
    var ready = Promise.race([warmed[img] || Promise.resolve(), new Promise(function (r) { setTimeout(r, 140); })]);
    ready.then(function () {
      if (token !== swapToken) return;
      if (t.getAttribute('data-srcset')) { mainImg.sizes = sizesAttr; mainImg.srcset = t.getAttribute('data-srcset'); } else { mainImg.removeAttribute('srcset'); }
      mainImg.src = img; mainImg.alt = alt;
      setLayer(t.getAttribute('data-slide'));
    });
  }
  // au clic, la bande garde la vignette suivante entièrement visible (et la précédente si la place le permet) : on voit qu'il y a une suite
  var thumbStrip = root.querySelector('.g-gal-thumbs');
  function revealNeighbours(t) {
    if (!thumbStrip || thumbStrip.scrollWidth <= thumbStrip.clientWidth + 2) return;
    var i = thumbs.indexOf(t), sr = thumbStrip.getBoundingClientRect(), sl = thumbStrip.scrollLeft, w = thumbStrip.clientWidth, pad = 8;
    var x = function (el, side) { var r = el.getBoundingClientRect(); return (side === 'l' ? r.left : r.right) - sr.left + sl; };
    var left = x(thumbs[i - 1] || t, 'l') - pad, right = x(thumbs[i + 1] || t, 'r') + pad, target = sl;
    if (right - left <= w) { if (right > sl + w) target = right - w; if (left < target) target = left; } else { target = right - w; }
    target = Math.max(0, Math.min(target, thumbStrip.scrollWidth - w));
    if (Math.abs(target - sl) > 1) { try { thumbStrip.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { thumbStrip.scrollLeft = target; } }
  }
  thumbs.forEach(function (t) {
    ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) { t.addEventListener(ev, function () { warm(t); }, { passive: true }); });
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
      t.classList.add('is-active'); t.setAttribute('aria-pressed', 'true');
      var img = t.getAttribute('data-img'), vid = t.getAttribute('data-video'), alt = t.getAttribute('data-alt') || '', text = t.getAttribute('data-cap') || '';
      if (vid && mainVid) {
        mainVid.hidden = false; mainImg.hidden = true;
        main.style.background = t.getAttribute('data-bg') || '';
        if (mainVid.getAttribute('data-current') !== vid) {
          mainVid.pause(); mainVid.innerHTML = '';
          if (t.getAttribute('data-poster')) mainVid.setAttribute('poster', t.getAttribute('data-poster'));
          addSources(mainVid, vid); mainVid.setAttribute('data-current', vid); mainVid.setAttribute('aria-label', alt); mainVid.load();
        }
        playSafe(mainVid);
      } else if (img && mainImg) {
        if (mainVid) { mainVid.pause(); mainVid.hidden = true; }
        main.style.background = ''; mainImg.hidden = false; showImg(t, img, alt);
      }
      if (cap) { cap.textContent = text; cap.hidden = !text; }
      revealNeighbours(t);
    });
  });
  // voisines préchargées au premier geste sur la galerie (pas pendant le chargement de la page)
  var galWrap = root.querySelector('.g-gallery');
  if (galWrap) {
    var warmAll = function () {
      thumbs.forEach(warm);
      ['pointerenter', 'touchstart', 'pointerdown'].forEach(function (ev) { galWrap.removeEventListener(ev, warmAll); });
    };
    ['pointerenter', 'touchstart', 'pointerdown'].forEach(function (ev) { galWrap.addEventListener(ev, warmAll, { passive: true }); });
    // filet : préchargement en tâche de fond une fois la page chargée et le navigateur au repos,
    // sauf connexion lente ou mode économie de données (le clic reste instantané sans attendre ce filet)
    var c = navigator.connection || {};
    if (!c.saveData && !/2g|slow-2g|3g/.test(c.effectiveType || '')) {
      var idle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(warmAll, { timeout: 4000 }); };
      if (document.readyState === 'complete') setTimeout(idle, 1500); else window.addEventListener('load', function () { setTimeout(idle, 1500); });
    }
  }
  // glissement du doigt (et de la souris) sur l'image principale : image suivante / précédente
  if (main && thumbs.length > 1) {
    var goTo = function (dir) {
      var i = -1;
      thumbs.forEach(function (t, k) { if (t.classList.contains('is-active')) i = k; });
      if (i < 0) i = 0;
      var n = i + dir;
      if (n < 0 || n >= thumbs.length) return;
      thumbs[n].click();
    };
    var sx = 0, sy = 0, swiping = false;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swiping = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;   // geste vertical = défilement de la page
      goTo(dx < 0 ? 1 : -1);
    }, { passive: true });
    var mx = null;
    main.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button === 0) mx = e.clientX; });
    main.addEventListener('pointerup', function (e) {
      if (mx === null) return;
      var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) >= 50) goTo(dx < 0 ? 1 : -1);
    });
    main.addEventListener('pointercancel', function () { mx = null; });
  }

  var strip = root.querySelector('.g-gal-thumbs');
  var prev = root.querySelector('.g-thumb-arrow--prev'), next = root.querySelector('.g-thumb-arrow--next');
  if (strip && prev && next) {
    var upd = function () { prev.disabled = strip.scrollLeft <= 2; next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2; };
    prev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }); });
    strip.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); setTimeout(upd, 300);
  }

  /* ── Lecteur de la vidéo explicative (son, contrôles natifs) ── */
  // lecteur santé : géré par le module pacha-video du thème (data-pv)

  /* ── Carrousel d'avis (technique home) ── */
  var track = root.querySelector('#gv2-rv-track');
  if (track) {
    var rp = root.querySelector('.g-rv-arrow--prev'), rn = root.querySelector('.g-rv-arrow--next');
    var step = function () { var c = track.querySelector('.g-rv-card'); return c ? c.getBoundingClientRect().width + 20 : 380; };
    if (rp) rp.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (rn) rn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* ── FAQ : pastilles « i » (prix relevés, sources), recalées dans l'écran ── */
  var chips = [].slice.call(root.querySelectorAll('.g-chip'));
  function closeChips() { chips.forEach(function (c) { c.classList.remove('is-open'); var p = c.querySelector('.g-chip-pop'); if (p) p.style.marginLeft = ''; }); }
  chips.forEach(function (chip) {
    var toggle = function (e) {
      e.preventDefault(); e.stopPropagation();
      var open = chip.classList.contains('is-open'); closeChips();
      if (!open) {
        chip.classList.add('is-open');
        var p = chip.querySelector('.g-chip-pop');
        if (p) { var r = p.getBoundingClientRect(), pad = 12, dx = r.left < pad ? pad - r.left : (r.right > window.innerWidth - pad ? window.innerWidth - pad - r.right : 0); p.style.marginLeft = dx + 'px'; }
      }
    };
    chip.addEventListener('click', toggle);
    chip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.g-chip')) closeChips(); });

  /* ── Trustpilot Micro Combo : rendu à 440px puis mis à l'échelle ── */
  var tpBoxes = [].slice.call(root.querySelectorAll('.g-tpfit'));
  function tpFit() {
    tpBoxes.forEach(function (box) {
      var w = box.querySelector('.trustpilot-widget'); if (!w) return;
      var avail = box.clientWidth || box.getBoundingClientRect().width; if (!avail) return;
      var s = Math.min(1, avail / 440);
      var center = box.classList.contains('g-tpfit--center') || (window.matchMedia('(max-width: 640px)').matches && box.closest('.g-hero'));
      if (center) { box.style.justifyContent = 'center'; w.style.transformOrigin = 'top center'; w.style.transform = 'scale(' + s.toFixed(4) + ')'; }
      else { box.style.justifyContent = 'flex-start'; w.style.transformOrigin = 'top left'; w.style.transform = 'translateX(' + (-25 * s).toFixed(2) + 'px) scale(' + s.toFixed(4) + ')'; }
      box.style.height = Math.ceil(22 * s) + 'px';
    });
  }
  if (tpBoxes.length) {
    tpFit(); window.addEventListener('resize', tpFit);
    if (window.ResizeObserver) { var tpObs = new ResizeObserver(function () { tpFit(); }); tpBoxes.forEach(function (b) { tpObs.observe(b); }); }
    [800, 2800].forEach(function (d) { setTimeout(tpFit, d); });
  }

  /* ── Barre collante (style 7 raisons) : desktop toujours visible sauf quand la box d'achat est à l'écran ; mobile après 120 px de scroll ── */
  // galerie collante : si plus haute que l'écran, on cale son bas (pas son haut) pour que la carte véto reste visible
  var gal = root.querySelector('.g-gallery');
  function fitGal() {
    if (!gal) return;
    if (window.innerWidth <= 980) { gal.style.top = ''; return; }
    var t = Math.min(107, window.innerHeight - gal.offsetHeight - 16);
    gal.style.top = t + 'px';
  }
  if (gal) { fitGal(); window.addEventListener('resize', fitGal); window.addEventListener('load', fitGal); [400, 1500].forEach(function (d) { setTimeout(fitGal, d); }); }

  // bulle Zipchat du thème (shadow DOM, 48 px en bas à gauche) : remontée au-dessus de la barre quand elle est visible sur mobile
  var chatObs = null;
  function liftChat(show) {
    var host = document.getElementById('zipchat-shadow-host');
    if (!host || !host.shadowRoot) return;
    var b = root.querySelector('.sticky-bar');
    var lift = show && window.innerWidth <= 640 && b ? (b.offsetHeight + 12) + 'px' : '';
    host.shadowRoot.querySelectorAll('div').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (getComputedStyle(el).position !== 'fixed' || r.width > 80 || r.width < 20) return;
      if (lift) { if (el.dataset.gv2Bottom === undefined) el.dataset.gv2Bottom = el.style.bottom || ''; el.style.setProperty('bottom', lift, 'important'); }
      else if (el.dataset.gv2Bottom !== undefined) { el.style.bottom = el.dataset.gv2Bottom; delete el.dataset.gv2Bottom; }
    });
    if (!chatObs && window.MutationObserver) {
      chatObs = new MutationObserver(function () { clearTimeout(chatObs.t); chatObs.t = setTimeout(function () { liftChat(root.querySelector('.sticky-bar').classList.contains('show')); }, 120); });
      chatObs.observe(host.shadowRoot, { childList: true, subtree: true });
    }
  }
  [1200, 4000].forEach(function (d) { setTimeout(function () { liftChat(root.querySelector('.sticky-bar').classList.contains('show')); }, d); });

  var bar = root.querySelector('.sticky-bar');
  var box = root.querySelector('.g-buybox');
  if (bar) {
    var boxSeen = true, lastShow = null, ticking = false;
    if (box && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { boxSeen = en[0].isIntersecting; schedule(); }).observe(box);
    } else if (box) { boxSeen = false; }
    var calc = function () {
      ticking = false;
      var show = window.innerWidth > 880 ? !boxSeen : (window.scrollY > 120 && !boxSeen);
      // tout en bas de la page : la barre s'efface pour laisser voir les derniers liens du pied de page
      var nearBottom = (window.scrollY + window.innerHeight) >= (document.documentElement.scrollHeight - 160);
      if (nearBottom) show = false;
      if (show === lastShow) return;
      lastShow = show;
      liftChat(show);
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      try { bar.inert = !show; } catch (e) {}
    };
    var schedule = function () { if (!ticking) { ticking = true; requestAnimationFrame(calc); } };
    window.addEventListener('scroll', schedule, { passive: true }); window.addEventListener('resize', function () { lastShow = null; schedule(); }); calc();
  }
})();
